function handleFreeSamples() {
  const tier1 = cartTiers?.tier_1 || {}
  const tier1Threshold = tier1.threshold !== '' ? Number(tier1.threshold) : false;
  const tier1Item = tier1.product;

  const tier2 = cartTiers?.tier_2 || {}
  const tier2Threshold = tier2.threshold !== '' ? Number(tier2.threshold) : false;
  const tier2Message = tier2.message;
  const tier2Collection = tier2.products;
  const tier2Limit = Number(tier2.limit) || 0;
  const isCartPage = document.body.classList.contains('template--cart');

  window.addEventListener('load', handleCartChange, { once: true });
  window.addEventListener('cartChange', handleCartChange);

  function handleCartChange(e) {
    // Fetch Cart object
    fetch(`${routes.cart_url}`, { ...fetchConfig() })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const cart = JSON.parse(state);

        manageThresholds(cart);
      })
      .catch((err) => console.log(err));
  }

  /**
   * Check if any thresholds are passed
   * @param {Object} cart
   */
  function manageThresholds(cart) {
    let freeLineItemIndex;
    let tier2Products = [];
    let tier2LineItemsIndexes = [];
    let freeSampleAdded;
    const freeProductsWrapper = document.querySelector('.free-products-popup__inner');
    const isTier2Empty =
      freeProductsWrapper && freeProductsWrapper.childElementCount == 0;
    const totalPrice = cart.total_price;
    const cartItems = cart.items;
    const isTier1Passed = isTierPassed(totalPrice, tier1Threshold);
    const isTier2Passed = isTierPassed(totalPrice, tier2Threshold);

    // Find free products in cart.
    cart.items.map((item, i) => {
      if (item.product_id === tier1Item.id) {
        freeLineItemIndex = i + 1;
        freeSampleAdded = item;
        return;
      }

      // Relies on '_tier_2_Product' private property.
      if (item.properties && item.properties._tier_2_Product) {
        tier2LineItemsIndexes.push(item.variant_id);
        tier2Products.push(item);
      }
    });

    // Tier 1 checks
    if (isTier1Passed && !freeSampleAdded) {
      const freeSampleTrigger = document.querySelector(
        '.free-sample-product-form button'
      );

      if (freeSampleTrigger) {
        if (isCartPage) {
          document.querySelector('[data-items-container]').classList.add('cart__items-container--disabled');
        }

        document.getElementById('cart-drawer').classList.add('cart-drawer--disabled');

        freeSampleTrigger.click();
      }
    } else if (!isTier1Passed && freeSampleAdded) {
      removeFreeProduct(freeLineItemIndex);
    }

    // Tier 2 checks. If settings are missing - skip logic.
    if (!tier2Limit || !tier2Collection || !tier2Threshold || isTier2Empty) {
      return;
    }

    const isLimitReached = tier2Limit === tier2Products.length;

    const popupShouldHide = isLimitReached && isTier2Passed || !isTier2Passed;
    const popupShouldShow = !isLimitReached && isTier2Passed;
    const shouldRemoveProducts = !isTier2Passed && tier2Products.length;

    if (popupShouldHide) {
      hidePopup();
    } else if (popupShouldShow) {
      showPopup();
    }

    if (shouldRemoveProducts) {
      // Use Shopify update API to remove multiple products with single request
      const updates = tier2LineItemsIndexes.reduce((acc, val, i) => {
        acc[val] = 0;
        return acc
      }, {})

      const body = JSON.stringify({
        updates: updates
      });

      const drawer = document.querySelector('cart-drawer')

      const updatedCart = new Promise((resolve, reject) => {
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((response) => {

            if (response) {
              resolve(response);
              return;
            }

            reject(response);
          })
          .catch((e) => {
            window.console.error(error);
          });
      });

      drawer.reRenderItems(updatedCart);
    }
  }

  function hidePopup() {
    const popup = document.querySelector('free-products-popup');
    if (!popup) return;
    popup.close()
  }

  function showPopup() {
    setTimeout(() => {
      const popup = document.querySelector('free-products-popup');

      if (!popup) return;

      popup.open();
    });
  }

  /**
   * Check if tier is reached.
   * @param {Number} currentTotal Current cart total price
   * @param {Number} threshold Upper limit
   * @returns Boolean
   */
  function isTierPassed(currentTotal, threshold) {
    if (!threshold) {
      return false;
    }

    return currentTotal >= threshold;
  }

  /**
   * Remove item from cart
   * @param {Number} lineItemIndex Cart line item index
   */
  function removeFreeProduct(lineItemIndex) {
    if (isCartPage) {
      document.querySelector('[data-items-container]').classList.add('cart__items-container--disabled');
    }

    document.getElementById('cart-drawer').classList.add('cart-drawer--disabled');

    const cartItem = document.getElementById(`CartDrawerItem-${lineItemIndex}`);

    if (!cartItem) return;

    const removeButton = cartItem.querySelector('cart-drawer-remove-button');

    removeButton.click();
  }
}

window.addEventListener('DOMContentLoaded', function () {
  handleFreeSamples();
});
